import React, { useState, useRef, useEffect } from 'react';
import HomeAnnouncements from './HomeAnnouncements';
import WelcomeCard from './WelcomeCard';
import QuickLinks from './QuickLinks';
import BirthdayCard from './BirthdayCard';
import UpcomingEvents from './UpcomingEvents';
import OfficePresence from './OfficePresence';

const HomePage = ({ currentUser }) => {
  const rightRef = useRef(null);
  const [rightHeight, setRightHeight] = useState(null);

  useEffect(() => {
    const el = rightRef.current;
    if (!el) return;
    const ro = new ResizeObserver(entries => setRightHeight(entries[0].contentRect.height));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div className="home-grid">
      <div className="home-left">
        <HomeAnnouncements currentUser={currentUser} isAdmin={currentUser.isAdmin} availableHeight={rightHeight} />
      </div>

      <div className="home-right" ref={rightRef}>
        <WelcomeCard currentUser={currentUser} />
        <QuickLinks />
        <BirthdayCard />
        <OfficePresence currentUser={currentUser} />
        <UpcomingEvents currentUser={currentUser} />
      </div>
    </div>
  );
};

export default HomePage;
